import {
    Alert,
    Backdrop,
    Box,
    Button,
    Card,
    Divider,
    FormGroup,
    Grid,
    IconButton,
    Snackbar,
    Typography,
} from '@mui/material'
import {makeStyles} from '@mui/styles'

import React, {useContext, useState} from 'react'
import {FormProvider, useForm, useWatch} from 'react-hook-form'
import themeMaker, {bssMakeStyles} from '../../lib/theming'
import __t from '../../lib/traduzioni'
import BSSAutocomplete from '../form/BSSAutocomplete'
import BSSSwitch from '../form/BSSSwitch'
import BSSText from '../form/BSSText'
import useBSSLogger from '../../hooks/useBSSLogger'
import {
    DefaultSubmitErrorHandler,
    NoPreviousData,
} from '../preventivo/Preventivo'
import DefaultLoadingComponent from '../form/DefaultLoadingComponent'
import {
    datiIntestazioneAttiviUtente,
    datiIntestazioneCrea,
    datiIntestazioneModifica,
    tipiPersona,
} from '../../api/datiintestazione'
import {retrieveNazioni} from '../../api/tnazioni'
import {AccediORegistrati} from '../preventivo/FormPagamenti'
import useSWRImmutable from 'swr/immutable'
import BSSForm from '../form/BSSForm'
import {WaitKC} from '../Wrapper'
import BSSErrorBar from '../BSSErrorBar'
import {SimpleCodFisc as CodFisc} from './CodFisc'
import {SimplePIVA as PIVA} from './PIVA'
import {countryToFlag} from '../preventivo/CercaNazione'
import BSSPreventivoContext from '../../contexts/BSSPreventivoContext'
import DefaultErrorComponent from '../form/DefaultErrorComponent'
import BSSButton from '../form/BSSButton'
import {Block, Edit} from '@mui/icons-material'
import {useTheme} from '@emotion/react'
import BSSSnackbar from '../form/BSSSnackbar'

const {logger} = useBSSLogger()

const linkformdatifatt = spedizioniweb2.getLinkFromPaginaPreventivo({nome: `step_datifatturazione`});

const DatiFatturazione = ({}) => {
    return (
        <>
            <WaitKC>
                <_DatiFatturazione />
            </WaitKC>
            <BSSErrorBar />
        </>
    )
}

const _DatiFatturazione = ({}) => {
    const classes = bssMakeStyles()

    const datiDefault = async () => {
        let dati = {}

        const nazioni = await retrieveNazioni()
        const tipiPersone = await tipiPersona()
        const datiAttivi = await datiIntestazioneAttiviUtente()

        dati = {
            nazioni,
            tipiPersone,
            datiAttivi,
        }

        logger.debug(
            'dati di default e da shortcode per dati fatturazione',
            dati,
        )

        return dati
    }

    const {
        data,
        error,
        mutate: aggiornaDatiFatturazione,
    } = useSWRImmutable('/api/initialDataDatiFatturazione', datiDefault, {
        onErrorRetry: (error, key, config, revalidate) => {
            return
            // if(error === "NO_PREVIOUS_DATA"){
            //     logger.debug("non ho dati pregressi!")
            //     return
            // }
        },
    })

    if (error) {
        logger.error(
            'errore reperimento dati iniziali dati fatturazione',
            error,
        )
        return <DefaultErrorComponent {...{error}} />
    }

    if (!error && !data) {
        return <DefaultLoadingComponent />
    }

    const {nazioni = [], tipiPersone = [], datiAttivi = {}} = data

    return (
        <>
            <Grid item xs={12} className={classes.formGroupBox}>
                <Card>
                    <FormProfiloDatiFatturazione
                        {...{
                            classes,
                            tipiPersone,
                            nazioni,
                            datiAttivi,
                            aggiornaDatiFatturazione,
                        }}
                    />
                </Card>
            </Grid>
        </>
    )
}

const datiFattDaContesto = (datiAttivi, tipiPersone, gruppooana) => {
    
    const dati = {
        ...datiAttivi,
        [gruppooana]: {
            ...(datiAttivi?.[gruppooana] ?? {}),
            tipopersona:
                tipiPersone.find(
                    (tp) => tp.value === (datiAttivi?.[gruppooana]?.tipopersona ?? null),
                ) ?? tipiPersone[0],
        },
    }

    return dati
}

const FormProfiloDatiFatturazione = ({
    classes,
    tipiPersone = [],
    nazioni = [],
    datiAttivi = {},
    aggiornaDatiFatturazione,
}) => {
    const gruppooana =
        (datiAttivi?.gruppo ?? null) !== null ? 'gruppo' : 'anagrafica'
    const [saveSuccess, setSavesuccess] = useState(false)
    const datiDef = datiFattDaContesto(datiAttivi, tipiPersone, gruppooana)

    const methods = useForm({
        defaultValues: {datifatt: datiDef},
    })

    logger.debug('dati fatturazione da contesto', datiDef)

    const {formState} = methods
    const {isSubmitted, isSubmitSuccessful, isSubmitting, isValidating} =
        formState

    const onSubmit = async (data) => {
        let nuoviDati = {}
        const dati = {
            ...data.datifatt,
        }
        const id = dati.id ?? null


        if (id === null) {
            nuoviDati = await datiIntestazioneCrea(dati)
        } else {
            nuoviDati = await datiIntestazioneModifica(dati)
        }

        logger.debug('dati fatturazione aggiornati', nuoviDati)
        aggiornaDatiFatturazione()

        setSavesuccess(true)
    }

    return (
        <>
            <FormProvider {...methods}>
                {/* <pre>{JSON.stringify(datiDef, null, 2)}</pre> */}
                {/* <pre>{JSON.stringify({isValidating, gruppooana}, null, 2)}</pre> */}

                <BSSForm
                    onSubmit={methods.handleSubmit(
                        onSubmit,
                        DefaultSubmitErrorHandler,
                    )}
                    methods={methods}
                >
                    <FormDatiFatturazione
                        {...{
                            methods,
                            classes,
                            nazioni,
                            tipiPersone,
                            mostraTitolo: false,
                        }}
                    />

                    <Grid item xs={12} className={classes.formGroupBox}>
                        <BSSButton
                            methods={methods}
                            type="submit"
                            size="large"
                            style={{fontWeight: 'bolder'}}
                            variant="contained"
                            color="primary"
                            fullWidth
                        >
                            {`${__t(gruppooana === 'anagrafica' ? 'salvadatifatturazione' : 'richiedimodificadatifatturazione')}`}
                        </BSSButton>
                    </Grid>
                </BSSForm>
            </FormProvider>

            <BSSSnackbar
                open={saveSuccess}
                onClose={(e) => setSavesuccess(false)}
            >
                <Alert
                    onClose={(e) => setSavesuccess(false)}
                    severity="success"
                >
                    {__t('datifattsaved')}
                </Alert>
            </BSSSnackbar>
        </>
    )
}

const FormDatiFatturazione = ({
    methods,
    classes,
    tipiPersone = [],
    nazioni = [],
    isodefault = 'IT',
    mostraTitolo = true,
    inPreventivo = false,
}) => {
    const listaNazioni = [
        nazioni.find((n) => n.iso === isodefault),
        ...nazioni.filter((n) => n.iso !== isodefault),
    ]
    const nazdef = listaNazioni[0]

    const theme = useTheme()

    const datiAttivi = methods.getValues()
    const gruppooana =
        ((datiAttivi?.datifatt ?? datiAttivi)?.gruppo ?? null) !== null
            ? 'gruppo'
            : 'anagrafica'

    const piva = useWatch({name: 'datifatt.partitaiva'})
    const codfisc = useWatch({name: 'datifatt.codicefiscale'})
    const nome = useWatch({name: 'datifatt.nome'})
    const cognome = useWatch({name: 'datifatt.cognome'})
    const tppers = useWatch({name: `datifatt.${gruppooana}.tipopersona`})
    const naz = useWatch({name: 'datifatt.nazione'})
    const pec = useWatch({name: 'datifatt.pec'})
    const codiceSdi = useWatch({name: 'datifatt.codiceSdi'})
    const ragionesociale = useWatch({name: 'datifatt.ragionesociale'})

    let isRequired = {}
    let exactLength = {}

    if ((tppers?.value ?? '').toUpperCase() === 'FISICA') {
        isRequired.codfisc = true
        exactLength.codfisc = 16
    }

    if (['FISICA', 'FISICAI'].includes((tppers?.value ?? '').toUpperCase())) {
        isRequired.nome = true
        isRequired.cognome = true
    }

    if (
        ['FISICAI', 'GIURIDICA', 'PA'].includes(
            (tppers?.value ?? '').toUpperCase(),
        )
    ) {
        isRequired.piva = true
    }

    if (['GIURIDICA', 'PA'].includes((tppers?.value ?? '').toUpperCase())) {
        isRequired.ragionesociale = true
    }

    if (
        ['FISICAI', 'GIURIDICA'].includes((tppers?.value ?? '').toUpperCase())
    ) {
        if (['', null, undefined].includes(pec)) {
            isRequired.codiceSdi = true
            exactLength.codiceSdi = 7
        }
        if (['', null, undefined].includes(codiceSdi)) {
            isRequired.pec = true
        }
    }

    if ((tppers?.value ?? '').toUpperCase() === 'PA') {
        isRequired.codiceSdi = true
        exactLength.codiceSdi = 6
    }

    if (isRequired.piva ?? false) {
        if ((naz?.iso ?? '').toUpperCase() === 'IT') {
            exactLength.piva = 11
        }
    }

    logger.debug('variazioni tra gli elementi osservati', {
        piva,
        codfisc,
        nome,
        cognome,
        tppers,
        naz,
        pec,
        codiceSdi,
        ragionesociale,
    })
    logger.debug(
        'campi required',
        isRequired,
        'lunghezza campi',
        exactLength,
        'codicesdi',
        codiceSdi,
    )

    const showOnlyRequired = (field) => {
        return (isRequired?.[field] ?? false) !== true
            ? {style: {display: 'none'}}
            : {}
    }

    const readOnly = inPreventivo && gruppooana === 'gruppo'
    const urlLink = linkformdatifatt?.permalink ?? linkformdatifatt?.link ?? null;
    const alertAction = (readOnly && (urlLink !== null)) ? {
        action: (
            <IconButton color={"warning"} onClick={e => window.open(urlLink, "_blank")}>
                <Edit />
            </IconButton>
        )
    } : {}

    return (
        <>
            {mostraTitolo && (
                <>
                    <Box px={2}>
                        <Typography variant="h6">
                            <Grid
                                container
                                style={{display: 'flex'}}
                                justify="space-between"
                            >
                                <Box sx={{flexGrow: 1}}>
                                    {__t('datifatturazione')}
                                </Box>
                                
                            </Grid>
                        </Typography>
                    </Box>
                    <Divider />
                </>
            )}

            {(gruppooana === "gruppo") && (
                <Alert severity="warning" {...alertAction}>
                    {__t("warndatifattgruppo")}
                </Alert>
            )}

            <Box p={2} display={{lg: 'flex'}} flexDirection="row" sx={{position: 'relative'}}>
                <Box mr={{lg: 1}} width={{xs: 1, md: 1, lg: 1 / 2}}>
                    <fieldset>
                        <legend>{__t('datianagrafici')}</legend>

                        <FormGroup row>
                            <Box width={{xs: 1, md: 1, lg: 1}} mb={'1.2em'}>
                                {/* <pre>{JSON.stringify(tipiPersone, null, 2)}</pre>*/}
                                {/* {<pre>{JSON.stringify(datiAttivi, null, 2)}</pre>}
            ana - {gruppooana}
            <pre>{JSON.stringify(methods.getValues(`datifatt.anagrafica.tipopersona`), null, 2)}</pre> 
            grp - {gruppooana}
            <pre>{JSON.stringify(methods.getValues(`datifatt.gruppo.tipopersona`), null, 2)}</pre>  */}

                                <BSSAutocomplete
                                    name={`datifatt.${gruppooana}.tipopersona`}
                                    label={__t('tipopersona')}
                                    methods={methods}
                                    dataProvider={async () => tipiPersone}
                                    ControllerProps={{
                                        rules: {
                                            required: __t(
                                                'validazione.requiredField',
                                                [__t('tipopersona')],
                                            ),
                                        },
                                    }}
                                    AutocompleteProps={{
                                        disableClearable: true,
                                        getOptionLabel: (option) =>
                                            option.text,
                                        renderOption: (
                                            props,
                                            option,
                                            {selected},
                                        ) => (
                                            <li {...props}>
                                                {option.text}
                                            </li>
                                        ),
                                    }}
                                />
                            </Box>
                        </FormGroup>

                        <FormGroup row {...showOnlyRequired('nome')}>
                            <Box width={{xs: 1, md: 1, lg: 1}} mb={'1.2em'}>
                                <BSSText
                                    name={`datifatt.nome`}
                                    label={`${__t('nome')}${
                                        isRequired.nome === true ? '*' : ''
                                    } `}
                                    methods={methods}
                                    ControllerProps={{
                                        rules: {
                                            required: {
                                                value: isRequired.nome,
                                                message: __t(
                                                    'validazione.requiredField',
                                                    ['nome'],
                                                ),
                                            },
                                        },
                                    }}
                                />
                            </Box>
                        </FormGroup>

                        <FormGroup row {...showOnlyRequired('cognome')}>
                            <Box width={{xs: 1, md: 1, lg: 1}} mb={'1.2em'}>
                                <BSSText
                                    name={`datifatt.cognome`}
                                    label={`${__t('cognome')}${
                                        isRequired.cognome === true
                                            ? '*'
                                            : ''
                                    } `}
                                    methods={methods}
                                    ControllerProps={{
                                        rules: {
                                            required: {
                                                value: isRequired.cognome,
                                                message: __t(
                                                    'validazione.requiredField',
                                                    ['cognome'],
                                                ),
                                            },
                                        },
                                    }}
                                />
                            </Box>
                        </FormGroup>

                        <FormGroup row {...showOnlyRequired('codfisc')}>
                            <Box width={{xs: 1, md: 1, lg: 1}} mb={'1.2em'}>
                                <BSSText
                                    name={`datifatt.codicefiscale`}
                                    label={`${__t('codicefiscale')}${
                                        isRequired.codfisc === true
                                            ? '*'
                                            : ''
                                    } `}
                                    TextFieldProps={{
                                        inputProps: {
                                            maxLength: 16,
                                            style: {
                                                textTransform: 'uppercase',
                                            },
                                        },
                                    }}
                                    methods={methods}
                                    ControllerProps={{
                                        rules: {
                                            required: {
                                                value: isRequired.codfisc,
                                                message: __t(
                                                    'validazione.requiredField',
                                                    [__t('codicefiscale')],
                                                ),
                                            },
                                            ...(exactLength.codfisc !==
                                            undefined
                                                ? {
                                                        pattern: {
                                                            value: new RegExp(
                                                                '.{' +
                                                                    exactLength.codfisc +
                                                                    '}',
                                                            ),
                                                            message: __t(
                                                                'validazione.patternField',
                                                                [
                                                                    __t(
                                                                        'codicefiscale',
                                                                    ),
                                                                    __t(
                                                                        'patterncodicefiscale',
                                                                    ),
                                                                ],
                                                            ),
                                                        },
                                                    }
                                                : {}),
                                        },
                                    }}
                                />
                            </Box>
                        </FormGroup>

                        <FormGroup
                            row
                            {...showOnlyRequired('ragionesociale')}
                        >
                            <Box width={{xs: 1, md: 1, lg: 1}} mb={'1.2em'}>
                                <BSSText
                                    name={`datifatt.ragionesociale`}
                                    label={`${__t('ragsoc')}${
                                        isRequired.ragionesociale === true
                                            ? '*'
                                            : ''
                                    } `}
                                    methods={methods}
                                    ControllerProps={{
                                        rules: {
                                            required: {
                                                value: isRequired.ragionesociale,
                                                message: __t(
                                                    'validazione.requiredField',
                                                    [__t('ragsoc')],
                                                ),
                                            },
                                            //required: __t("validazione.requiredField", [__t("ragionesociale")])
                                        },
                                    }}
                                />
                            </Box>
                        </FormGroup>

                        <FormGroup row {...showOnlyRequired('piva')}>
                            <Box width={{xs: 1, md: 1, lg: 1}} mb={'1.2em'}>
                                <BSSText
                                    name={`datifatt.partitaiva`}
                                    label={`${__t('partitaiva')}${
                                        isRequired.piva === true ? '*' : ''
                                    } `}
                                    TextFieldProps={{
                                        inputProps: {
                                            maxLength:
                                                exactLength.piva ?? 99,
                                        },
                                    }}
                                    methods={methods}
                                    ControllerProps={{
                                        rules: {
                                            required: {
                                                value: isRequired.piva,
                                                message: __t(
                                                    'validazione.requiredField',
                                                    [__t('partitaiva')],
                                                ),
                                            },
                                        },
                                    }}
                                />
                            </Box>
                        </FormGroup>

                        <FormGroup row>
                            <Box width={{xs: 1, md: 1, lg: 1}} mb={'1.2em'}>
                                <BSSText
                                    name={`datifatt.pec`}
                                    label={`${__t('pec')}${
                                        isRequired.pec === true ? '*' : ''
                                    } `}
                                    methods={methods}
                                    TextFieldProps={{
                                        inputProps: {type: 'email'},
                                    }}
                                    ControllerProps={{
                                        rules: {
                                            required: {
                                                value: isRequired.pec,
                                                message: __t(
                                                    'validazione.requiredField',
                                                    [__t('pec')],
                                                ),
                                            },
                                            email: __t('validazione.email'),
                                        },
                                    }}
                                />
                            </Box>
                            <Box width={{xs: 1, md: 1, lg: 1}} mb={'1.2em'}>
                                <BSSText
                                    name={`datifatt.codiceSdi`}
                                    label={`${__t('codicesdi')}${
                                        isRequired.codiceSdi === true
                                            ? '*'
                                            : ''
                                    } `}
                                    methods={methods}
                                    TextFieldProps={{
                                        inputProps: {
                                            maxLength:
                                                exactLength.codiceSdi ?? 7,
                                        },
                                    }}
                                    ControllerProps={{
                                        rules: {
                                            //required: __t("validazione.requiredField", [__t("codicesdi")]),
                                            required: {
                                                value: isRequired.codiceSdi,
                                                message: __t(
                                                    'validazione.requiredField',
                                                    [__t('codicesdi')],
                                                ),
                                            },
                                            ...(exactLength.codiceSdi !==
                                            undefined
                                                ? {
                                                        pattern: {
                                                            value: new RegExp(
                                                                '\\d{' +
                                                                    exactLength.codiceSdi +
                                                                    '}',
                                                            ),
                                                            message: __t(
                                                                'validazione.patternField',
                                                                [
                                                                    __t(
                                                                        'codicesdi',
                                                                    ),
                                                                    __t(
                                                                        'patterncodicesdi',
                                                                    ),
                                                                ],
                                                            ),
                                                        },
                                                    }
                                                : {}),
                                        },
                                    }}
                                />
                            </Box>
                        </FormGroup>

                        <FormGroup row>
                            <Box width={{xs: 1, md: 1, lg: 1}} mb={'1.2em'}>
                                <BSSSwitch
                                    name={`datifatt.vies`}
                                    label={__t('vies')}
                                    methods={methods}
                                />
                            </Box>
                        </FormGroup>
                    </fieldset>
                </Box>

                <Box ml={{lg: 1}} width={{xs: 1, md: 1, lg: 1 / 2}}>
                    <fieldset>
                        <legend>{__t('indirizzo')}</legend>

                        <Grid container direction="row">
                            <Grid item width={{xs: 1, md: 8 / 10}} mb={'1.2em'}>
                                <BSSAutocomplete
                                    name={'datifatt.nazione'}
                                    label={__t('nazione') + '*'}
                                    methods={methods}
                                    dataProvider={async () => {
                                        return listaNazioni
                                    }}
                                    ControllerProps={{
                                        rules: {
                                            required: __t(
                                                'validazione.requiredField',
                                                [__t('nazione')],
                                            ),
                                        },
                                        defaultValue: nazdef,
                                    }}
                                    AutocompleteProps={{
                                        getOptionLabel: (option) =>
                                            option.nazione,
                                        renderOption: (
                                            props,
                                            option,
                                            {selected},
                                        ) => (
                                            <li {...props}>
                                                <div>
                                                    {countryToFlag(
                                                        option.iso,
                                                    )}{' '}
                                                    {option.nazione}
                                                </div>
                                            </li>
                                        ),
                                    }}
                                />
                            </Grid>

                            <Grid item width={{xs: 1, md: 2 / 10}} mb={'1.2em'}>
                                <BSSText
                                    name={`datifatt.provincia`}
                                    label={__t('isoprov') + '*'}
                                    methods={methods}
                                    TextFieldProps={{
                                        inputProps: {maxLength: 2},
                                    }}
                                    ControllerProps={{
                                        rules: {
                                            required: __t(
                                                'validazione.requiredField',
                                                [__t('isoprovincia')],
                                            ),
                                        },
                                    }}
                                />
                            </Grid>
                        </Grid>

                        <Grid container direction="row">
                            <Grid item
                                width={{xs: 1, md: 1 / 3, lg: 1 / 4}}
                                mb={'1.2em'}
                            >
                                <BSSText
                                    name={`datifatt.cap`}
                                    label={__t('cap') + '*'}
                                    methods={methods}
                                    ControllerProps={{
                                        rules: {
                                            required: __t(
                                                'validazione.requiredField',
                                                [__t('cap')],
                                            ),
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid item
                                width={{xs: 1, md: 2 / 3, lg: 3 / 4}}
                                mb={'1.2em'}
                            >
                                <BSSText
                                    name={`datifatt.citta`}
                                    label={__t('citta') + '*'}
                                    methods={methods}
                                    ControllerProps={{
                                        rules: {
                                            required: __t(
                                                'validazione.requiredField',
                                                [__t('citta')],
                                            ),
                                        },
                                    }}
                                />
                            </Grid>
                        </Grid>

                        <Grid container direction="row">
                            <Grid item width={{xs: 1, md: 8 / 10}} mb={'1.2em'}>
                                <BSSText
                                    name={`datifatt.indirizzofatturazione`}
                                    label={__t('indirizzo') + '*'}
                                    methods={methods}
                                    ControllerProps={{
                                        rules: {
                                            required: __t(
                                                'validazione.requiredField',
                                                [
                                                    __t(
                                                        'indirizzofatturazione',
                                                    ),
                                                ],
                                            ),
                                        },
                                    }}
                                />
                            </Grid>

                            <Grid item width={{xs: 1, md: 2 / 10}} mb={'1.2em'}>
                                <BSSText
                                    name={`datifatt.civico`}
                                    label={__t('civico') + '*'}
                                    methods={methods}
                                    ControllerProps={{
                                        rules: {
                                            required: __t(
                                                'validazione.requiredField',
                                                [__t('civico')],
                                            ),
                                        },
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </fieldset>

                    <fieldset>
                        <legend>{__t('contatti')}</legend>

                        <Grid container direction="row">
                            <Grid item
                                width={{xs: 1, md: 1 / 3, lg: 1 / 4}['md']}
                                mb={'1.2em'}
                            >
                                <BSSText
                                    name={`datifatt.prefissotelefono`}
                                    label={__t('prefisso') + '*'}
                                    methods={methods}
                                    ControllerProps={{
                                        rules: {
                                            required: __t(
                                                'validazione.requiredField',
                                                [__t('prefisso')],
                                            ),
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid item
                                width={{xs: 1, md: 2 / 3, lg: 3 / 4}['md']}
                                mb={'1.2em'}
                            >
                                <BSSText
                                    name={`datifatt.numerotelefono`}
                                    label={__t('telefono') + '*'}
                                    methods={methods}
                                    ControllerProps={{
                                        rules: {
                                            required: __t(
                                                'validazione.requiredField',
                                                [__t('numero')],
                                            ),
                                        },
                                    }}
                                />
                            </Grid>
                        </Grid>

                        <FormGroup row>
                            <Box width={{xs: 1, md: 1, lg: 1}} mb={'1.2em'}>
                                <BSSText
                                    name={`datifatt.email`}
                                    label={__t('mail') + '*'}
                                    methods={methods}
                                    TextFieldProps={{
                                        inputProps: {type: 'email'},
                                    }}
                                    ControllerProps={{
                                        rules: {
                                            email: __t('validazione.email'),
                                        },
                                    }}
                                />
                            </Box>
                        </FormGroup>

                        
                    </fieldset>
                </Box>

                {readOnly && (
                    <Backdrop
                        open={true}
                        sx={{
                            cursor: 'not-allowed',
                            position: 'absolute',
                            inset: 0,
                        }}
                    ></Backdrop>
                )}

            </Box>
        </>
    )
}

export default DatiFatturazione
export {FormDatiFatturazione, datiFattDaContesto}
